export default __webpack_public_path__ + "static/media/web-app-background.ad0288ed.svg";